import React from 'react';
import LoadingEventTile from '../../Tiles/LoadingEventTile';
import TileSet from '../index';

const LoadingTileSet = () => {
  return (
    <TileSet>
      <LoadingEventTile />
      <LoadingEventTile />
      <LoadingEventTile />
      <LoadingEventTile />
      <LoadingEventTile />
      <LoadingEventTile />
    </TileSet>
  );
};

export default LoadingTileSet;
